module.exports = __webpack_public_path__ + "img/example-litterature-contest-qr-code.65fb800e.jpg";